const localState = {
    list: null,
    tag: {
        name: '',
        skills: [],
        instruments: [],
    },
}

const mutations = {
    setState: (state, {
        key,
        data,
    }) => {
        state[key] = data
    },
}

const actions = {
    async fetch({
        commit,
    }) {
        const response = await this.$api.tags.fetch()

        commit('setState', {
            key: 'list',
            data: response.data.data || [],
        })
    },
    async add({
        state,
    }) {
        const tag = {
            ...state.tag,
        }
        tag.instruments = tag.instruments.map((item) => item.id)
        tag.skills = tag.skills.map((item) => item.id)

        return await this.$api.tags.add(tag)
    },
    async update({ state }, id) {
        const tag = {
            ...state.tag,
        }
        tag.instruments = tag.instruments.map((item) => item.id)
        tag.skills = tag.skills.map((item) => item.id)

        return await this.$api.tags.update(id, tag)
    },
    async remove(_, id) {
        return await this.$api.tags.remove(id)
    },
}

const getters = {
    list: (state) => state.list,
    tag: (state) => state.tag,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
